import axios from 'axios';
import { API_CONFIG } from '@/constants/api';

/**
 * Create an axios instance with default configuration for the API.
 *
 * @returns {AxiosInstance}
 */
const api = axios.create({
    baseURL: API_CONFIG.BASE_URL,
    withCredentials: true,
    timeout: 120000, // 120 seconds
    headers: {
        'Content-Type': 'application/json',
    },
});

/**
 * Response interceptor to handle session expiration.
 * Redirects to auth page when API returns 401. A 403 is a permission decision, not an expired
 * session, so it is left for the caller to show.
 */
api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            // Avoid redirect loop if already on auth page
            if (!window.location.pathname.startsWith('/auth')) {
                window.location.href = '/auth?error=session_expired';
            }
        }

        return Promise.reject(error);
    }
);

export default api;
